<template>
  <!-- UPPER HALF: Image Carousel -->
  <div class="upper-half-carousel">
    <v-carousel
      cycle
      hide-delimiter-background
      delimiter-icon="mdi-circle-small"
      class="full-width-carousel"
      :height="carouselHeight"
      hide-arrows-on-hover
    >
      <v-carousel-item
        v-for="(image, index) in images"
        :key="index"
      >
        <v-img
          :src="image"
          class="fill-image"
          cover
        />
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // Adjust the carousel height as needed
      carouselHeight: '70vh',

      // Replace these with your own local or external paths
      images: [
        'images/lovina6.jpg',
        'images/lovina8.jpg',
        'images/lovina7.jpg',
        'images/lovina5.jpg',
      //   'images/lovina9.jpg',
      //   'images/lovina11.jpg',
      //   'images/lovina12.jpg',
      //   'images/lovina13.jpg',
      //   'images/lovina14.jpg',
      //   'images/lovina15.jpg',
       ]
    };
  }
};
</script>

<style scoped>
.upper-half-carousel {
  width: 100%;
  height: 70vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

@media (max-width: 600px) {
  .upper-half-carousel {
    height: 70vh; /* Reduced height for smaller screens */
  }
}

.full-width-carousel {
  width: 100%;
  height: 100%;
}

.fill-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
